/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { MagazineCollection } from "../issue-landing-page";
import { MagazineEditions } from "@quintype/arrow";
import "../issue-landing-page/issue-landing-page.m.css";

export const MagazineArchivePage = ({ data = {}, config = {} }) => {
  const { rows: magazineRows = [], pageSetting = {} } = get(config, ["pagebuilder-config", "magazine", "archive"], {});
  if (!magazineRows.length) return <div styleName="info-message">Magazine configuration is missing.</div>;

  const { magazineDescription = "", entityId, magazineSlug = "", allEditions = [], magazineTitle = "" } = data;

  return (
    <>
      {magazineRows.map(row => {
        const { name, layout, config } = row;
        switch (name) {
          case "headerEdition":
            const collection = {
              "associated-metadata": {
                config: {
                  pageDescription: magazineDescription,
                  ...config,
                  pageTitle: magazineTitle,
                  enableBorder: true,
                  customUrlPath: `/subscription?group=${magazineSlug}`
                },
                layout: layout
              }
            };
            return <MagazineCollection key={name} collection={collection} layout={layout} metadata={{}} />;

          case "allEditions":
            const { subsequentLoadCount = 8, initialLoadCount = 12, sortBy, showButton = true } = config;

            const [editions, updateEditions] = useState(allEditions);
            const [limit, handleLimit] = useState(initialLoadCount);
            const [offset, handleOffset] = useState(initialLoadCount);
            const showLoadmoreButton = showButton && !allEditions.length < initialLoadCount;
            const [showLoadMore, handleLoadMore] = useState(showLoadmoreButton);

            const loadMoreIssues = async () => {
              const sortByOrder = sortBy === "latest-issues" ? "desc" : "asc";
              try {
                const data = await fetch(
                  `/api/v1/entity/${entityId}/collections?limit=${subsequentLoadCount}&offset=${offset}&sort-by=collection-date&order=${sortByOrder}`
                );
                const result = await data.json();
                const newEditions =
                  result &&
                  result.collections.map(item => {
                    return {
                      collection: item
                    };
                  });
                const otherEditions = [...editions, ...newEditions];
                const updatedOffset = subsequentLoadCount + offset;
                handleOffset(updatedOffset);
                (otherEditions === [] || otherEditions.length < updatedOffset) && handleLoadMore(false);
                updateEditions(otherEditions);
                handleLimit(limit + subsequentLoadCount);
              } catch (err) {
                console.error(`failed to get other editions data: ${err}`);
              }
            };

            if (editions.length) {
              return (
                <div styleName="editions-wrapper">
                  <MagazineEditions
                    key={name}
                    collection={editions}
                    config={{
                      ...{ theme: pageSetting.bgColor },
                      ...config,
                      magazineSlug,
                      template: "SubsequentLoadCount"
                    }}
                    onClick={loadMoreIssues}
                    showLoadmore={showLoadMore}
                    limit={offset}
                  />
                </div>
              );
            }
        }
      })}
    </>
  );
};

MagazineArchivePage.propTypes = {
  data: PropTypes.shape({
    magazineDescription: PropTypes.string,
    magazineSlug: PropTypes.string,
    allEditions: PropTypes.array,
    magazineTitle: PropTypes.string
  }),
  config: PropTypes.shape({
    "pagebuilder-config": PropTypes.shape({
      magazine: PropTypes.shape({
        archive: PropTypes.shape({
          rows: PropTypes.array,
          pageSetting: PropTypes.object
        })
      })
    })
  })
};
